import React, { Component } from "react";
import AuthService from "services/auth.service";
import queryString from "query-string";
import ChatSessionService from "services/chat-session.service";
import IconSearch from "assets/icons/Search.svg";
import FilterIcon from "assets/icons/Filter.svg";
import UnreadChatCountIcon from "assets/icons/unread-chat-icon.svg";
import { ChatList } from "./ChatList";
import ChatSession from "./ChatSession";
import { Container, Row, Col } from "react-bootstrap";
import { Tabs, Tab } from "react-bootstrap";
import Pagination from "react-bootstrap/Pagination";
import Spinner from "react-bootstrap/Spinner";
import { Client as ConversationsClient } from "@twilio/conversations";
import moment from "moment";
import "pages/Teleconsult/Teleconsult.scss";
import { DocereeBannerSection } from "components/DocereeBanner/DocereeBannerSection";
import * as Sentry from "@sentry/react";

class Teleconsult extends Component {
  constructor(props) {
    super(props);

    this.state = {
      chats: [],
      total_pages: 1,
      page: 1,
      current_type: "",
      unread_count: 0,
      search: "",
      chats_loading: false,
      chat: {},
      tokens: [],
      token: null,
      statusString: null,
      conversationsReady: false,
      conversations: [],
      selectedConversationSid: null,
      selectedConversation: null,
      newMessage: "",
      status: "default",
      doReset: false,
      current_token: null,
      showFilter: false,
      filterBy: "",
    };

    this.setSelectedChat = this.setSelectedChat.bind(this);
  }

  componentDidMount() {
    this.onChatTabSelect("ongoing");
  }

  componentWillUnmount() {
    if (this.conversationsClient) {
      this.conversationsClient.shutdown();
    }
  }

  onChatTabSelect(type) {
    this.setState(
      {
        selectedConversation: null,
        doReset: true,
        current_type: type,
      },
      () => {
        this.getChatSessions(1);
      }
    );
  }

  onChatFilterSelect(user_type) {
    this.setState(
      {
        selectedConversation: null,
        doReset: true,
        user_type: user_type,
      },
      () => {
        this.getChatSessions(1);
        this.setState({
          showFilter: false,
        });
      }
    );
  }

  getChatSessions(page) {
    this.setState({ chats_loading: true, page: page });

    const parameters = queryString.stringify({
      page: page,
      per_page: 10,
      type: this.state.current_type,
      user_type: this.state.user_type,
      query: this.state.search,
      is_twilio: true,
    });

    ChatSessionService.list(this.state.current_type, parameters)
      .then(
        (data) => {
          let chats = data.chat_sessions.map((c) => {
            let isInBuffer = false;
            let hasStarted = true;
            if (c.video_session) {
              isInBuffer = new moment().isBetween(
                new moment(c.video_session.start_at * 1000).subtract(
                  c.chat_buffer
                ),
                new moment(c.start_at * 1000)
              );
              hasStarted =
                isInBuffer || c.video_session.start_at < new moment().unix();
            }
            c.isInBuffer = isInBuffer;
            c.hasStarted = hasStarted;
            return c;
          });
          this.setState({
            chats: chats,
            page: data.metadata.current_page,
            total_pages: data.metadata.total_pages,
            unread_count: data.metadata.unread_count,
            filterBy: data.metadata.filter_by,
          });
        },
        (error) => {
          if (error.response.status === 401) {
            AuthService.logout();
            window.location.replace("/eb/login");
          }
        }
      )
      .then(() => {
        this.setState({ chats_loading: false });
      });
  }

  setSelectedChat(chat) {
    if (this.conversationsClient) {
      this.conversationsClient.shutdown();
    }
    this.setState({ chat: chat, doReset: false }, () => {
      if (this.state.tokens.length === 0) {
        this.getTwilioTokens();
      } else {
        this.handleTokenChange();
      }
    });
  }

  // for twilio conversations
  getTwilioTokens() {
    ChatSessionService.getTwilioTokens().then(
      (data) => {
        if ("tokens" in data) {
          this.setState(
            {
              tokens: data.tokens,
            },
            () => {
              this.handleTokenChange();
            }
          );
        }
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace("/eb/login");
        }
      }
    );
  }

  async setSelectedConversation() {
    this.conversationsClient
      .getConversationBySid(this.state.chat.twilio_sid)
      .then((con) => this.setState({ selectedConversation: con }));
  }

  searchChat(e) {
    if (e.key === "Enter") {
      this.getChatSessions(1);
    }
  }

  handleTokenChange() {
    this.token = this.state.tokens.find((obj) => {
      return obj.id === this.state.chat.token_id;
    });
    this.setState(
      {
        current_token: this.token,
      },
      () => {
        this.initConversations();
      }
    );
  }

  initConversations = async () => {
    this.conversationsClient = await new ConversationsClient(
      this.state.current_token.token
    );
    this.conversationsClient.on("stateChanged", (state) => {
      if (state === "initialized") {
        this.setState(
          {
            status: "success",
          },
          () => {
            this.setSelectedConversation();
          }
        );
      } else {
        this.setState({
          status: "error",
        });
      }
    });
    this.conversationsClient.on("connectionStateChanged", (state) => {
      this.setTwilioState(state);
    });

    this.conversationsClient.on("tokenAboutToExpire", async () => {
      try {
        await this.conversationsClient.updateToken(this.state.current_token.token);
      } catch (error) {
        Sentry.captureMessage(`Error refreshing token`, {level: "info", extra: error});
        this.setState({
          status: "error",
          statusString: "Failed to refresh token.",
        });
      }
    });

    this.conversationsClient.on("tokenExpired", async () => {
      try {
        await this.conversationsClient.updateToken(this.state.current_token.token);
      } catch (error) {
        Sentry.captureMessage(`Error refreshing expired token`, {level: "info", extra: error});
        this.setState({
          status: "error",
          statusString: "Token expired. Reconnect required.",
        });
      }
    });

    // Handle client errors
    this.conversationsClient.on("connectionError", (error) => {
      Sentry.captureMessage(`Connection error`, {level: "info", extra: error});
      this.setState({
        status: "error",
        statusString: "Connection error occurred.",
      });
    });
  };

  setTwilioState(twilio_state) {
    if (twilio_state === "connecting")
      this.setState({
        statusString: "Connecting to Twilio…",
        status: "default",
      });
    if (twilio_state === "connected") {
      this.setState({
        statusString: "You are connected.",
        status: "success",
      });
    }
    if (twilio_state === "disconnecting")
      this.setState({
        statusString: "Disconnecting from Twilio…",
        conversationsReady: false,
        status: "default",
      });
    if (twilio_state === "disconnected")
      this.setState({
        statusString: "Disconnected.",
        conversationsReady: false,
        status: "warning",
      });
    if (twilio_state === "denied")
      this.setState({
        statusString: "Failed to connect.",
        conversationsReady: false,
        status: "error",
      });
  }

  setShowActions(state) {
    this.setState({
      showFilter: state,
    });
  }

  render() {
    let chatTypes = [
      { type: "ongoing", name: "Ongoing" },
      { type: "upcoming", name: "Upcoming" },
      { type: "history", name: "History" },
    ];

    const PaginationSection = () => {
      const items = [];

      if (this.state.page >= 3) {
        items.push(
          <>
            <Pagination.First onClick={(p) => this.getChatSessions(1)} />
            <Pagination.Prev
              onClick={(p) => this.getChatSessions(this.state.page - 1)}
            />
            <Pagination.Ellipsis />
          </>
        );
      }

      if (this.state.page <= this.state.total_pages) {
        const midNumbers = [];
        if (this.state.page - 1 >= 1) {
          midNumbers.push(this.state.page - 1);
        }
        midNumbers.push(this.state.page);
        if (this.state.page + 1 <= this.state.total_pages) {
          midNumbers.push(this.state.page + 1);
        }
        midNumbers.forEach((x, i) =>
          items.push(
            <Pagination.Item
              key={`paginate-${i}`}
              active={x === this.state.page}
              onClick={(p) => this.getChatSessions(p.target.text)}
            >
              {x}
            </Pagination.Item>
          )
        );
      }

      if (this.state.page <= this.state.total_pages - 2) {
        items.push(
          <>
            <Pagination.Ellipsis />
            <Pagination.Next
              onClick={(p) => this.getChatSessions(this.state.page + 1)}
            />
            <Pagination.Last
              onClick={(p) => this.getChatSessions(this.state.total_pages)}
            />
          </>
        );
      }

      return (
        <Pagination size="sm">
          {items.map((x, i) => (
            <React.Fragment key={`page-${i}`}>{x}</React.Fragment>
          ))}
        </Pagination>
      );
    };

    const ChatFilter = () => {
      const currentUser = AuthService.getCurrentUser();

      const filters = [
        { label: 'Trial',value: 'trial', only_nutritionist: true },
        { label: 'Premium',value: 'premium', only_nutritionist: true },
        { label: 'Premium+',value: 'three_months', only_nutritionist: true },
        { label: 'Unread',value: 'unread', only_nutritionist: false },
        { label: '90DaysMom',value: 'ninety_days_mom', only_nutritionist: true },
        { label: 'On Demand',value: 'on_demand', only_nutritionist: false },
        { label: 'Reset All',value: '', only_nutritionist: false }
      ]

      return (
        <span className="float-right position-relative font-size-4">
          <button
            className="border-0 filter-icon rounded-circle"
            onClick={() => this.setShowActions(!this.state.showFilter)}
          >
            <img src={FilterIcon} alt="filter" />
          </button>

          <div
            id="filter-actions"
            className="conditional-display"
            displayed={this.state.showFilter.toString()}
          >
            {filters.map((filter, index) => {
              if((filter.only_nutritionist && currentUser?.is_bookdoc_nutritionist) || !filter.only_nutritionist){
                return (
                  <div className={`action-child px-4 py-4 ${ this.state.filterBy === filter.value ? "active" : ""}`} onClick={() => this.onChatFilterSelect(filter.value)} key={`filter-key-${index}`}>
                    {filter.label}
                  </div>
                )
              }
            })}
          </div>
        </span>
      );
    };

    return (
      <div id="teleconsult-main">
        <DocereeBannerSection />
        <Container fluid>
          <Row className="wrapper">
            <Col md={3} className="chats-list-container scrollbar-grey">
              <div className="chat-additional-details shadow-sm">
                <div className="unread-container d-flex align-items-end">
                  <div className="unread-count">
                    <img src={UnreadChatCountIcon} alt="chat-bubble-img" />
                    <span className="badge badge-warning" id="unread-count">
                      {this.state.unread_count || 0}
                    </span>
                  </div>

                  <ChatFilter />
                </div>
              </div>
              <Tabs
                defaultActiveKey="ongoing"
                className="flex-nowrap chat-tabs"
                id="chat-tabs"
                onSelect={(k) => this.onChatTabSelect(k)}
              >
                {chatTypes.map((chatType, index) => (
                  <Tab
                    eventKey={chatType.type}
                    title={chatType.name}
                    key={`chat-tab-${index}`}
                  >
                    {(() => {
                      if (this.state.chats_loading) {
                        return (
                          <div className="loader">
                            <Spinner animation="border" className="spinner" />
                          </div>
                        );
                      } else {
                        return (
                          <React.Fragment>
                            <div className="chats-search-box d-block">
                              <img
                                src={IconSearch}
                                alt="search-icon"
                                id="search-icon"
                              />
                              <input
                                type="text"
                                placeholder="Search"
                                className="form-control"
                                value={this.state.search}
                                onChange={(e) =>
                                  this.setState({ search: e.target.value })
                                }
                                onKeyDown={(e) => this.searchChat(e)}
                              />
                            </div>
                            <ChatList
                              chats={this.state.chats}
                              setSelectedChat={this.setSelectedChat}
                              chatType={chatType.type}
                            />
                            {this.state.chats.length > 0 && (
                              <PaginationSection />
                            )}
                          </React.Fragment>
                        );
                      }
                    })()}
                  </Tab>
                ))}
              </Tabs>
            </Col>
            <Col md={9} className="chat-session-container scrollbar-grey">
              <ChatSession
                chat={this.state.chat}
                conversationStatus={this.state.status}
                selectedConversation={this.state.selectedConversation}
                doReset={this.state.doReset}
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Teleconsult;
